import { render, staticRenderFns } from "./AskAQuestionConfirmation.vue?vue&type=template&id=30fbefcf&"
import script from "./AskAQuestionConfirmation.vue?vue&type=script&lang=js&"
export * from "./AskAQuestionConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports